import * as types from 'src/store/types';
import { CREATION_TYPE } from 'src/const/state/campaign';
import * as service from 'src/service/efficient-tool';

const SET_LOADING_STATE = `campaign/adgroup/${types.SET_LOADING_STATE}`;

const efficientTool = {
  namespaced: true,
  state: {
    versionObjectiveData: null, // version 对应的 objective 数据
    creationType: '', // 创编类型, 区分是普通创编还是使用效率工具的创编
    versionActionType: '', // version 的操作类型, 区分当前是新建、编辑 version
  },
  getters: {
    isCampaignPlanerCreation(state) {
      return state.creationType === CREATION_TYPE.campaignPlaner;
    },
    isCampaignPlanerCreate(state) {
      return state.versionActionType === 'create';
    },
    isCampaignPlanerEdit(state) {
      return state.versionActionType === 'edit';
    },
    rfCreationType(state, getters) { // rnf 埋点使用，区分cp和normal rnf
      return getters.isCampaignPlanerCreation ? 'campaign-forecaster' : 'normal';
    },
  },
  mutations: {
    [types.SET_CREATION_TYPE](state, type = CREATION_TYPE.campaignPlaner) {
      state.creationType = type;
    },
    [types.SET_VERSION_ACTION_TYPE](state, type = 'create') {
      state.versionActionType = type;
    },
    [types.SET_VERSION_OBJECTIVE_DATA](state, data) {
      state.versionObjectiveData = data;
    },
  },
  actions: {
    /**
     * 创建 plan
     * @param {*} store
     * @param {*} postData 提交的 plan 数据
     * @returns 返回接口的数据
     */
    async submitCreatePlan({ commit }, postData) {
      let data;
      try {
        data = await service.createPlan(postData);
      } catch (err) {
        data = {};
      }
      return data;
    },
    /**
     * 创建 version
     *
     * @param {*}
     * @param {*} postData 提交的 version 数据
     * @returns 返回接口的数据
     */
    async submitCreateVersion({ commit }, postData) {
      let data;
      try {
        commit(SET_LOADING_STATE, { status: true }, { root: true });
        data = await service.createVersion(postData);
        commit(SET_LOADING_STATE, { status: false }, { root: true });
      } catch (err) {
        data = {};
        commit(SET_LOADING_STATE, { status: false }, { root: true });
      }
      return data;
    },

    /**
     * 更新 version
     *
     * @param {*}
     * @param {*} postData 提交的 version 数据
     * @returns 返回接口的数据
     */
    async submitUpdateVersion({ commit }, postData) {
      let data;
      try {
        commit(SET_LOADING_STATE, { status: true }, { root: true });
        data = await service.updateVersion(postData);
        commit(SET_LOADING_STATE, { status: false }, { root: true });
      } catch (err) {
        data = {};
        commit(SET_LOADING_STATE, { status: false }, { root: true });
      }
      return data;
    },

    /**
     * 获取 version 详情
     *
     * @param {*}
     * @param {*} params 包含 version id 的参数
     * @returns 返回 version 信息
     */
    async getVersionDetail({ commit }, params) {
      let data;
      try {
        data = await service.getVersion(params);
      } catch (err) {
        data = {};
      }
      return data;
    },
  },

};

export default efficientTool;
